export const name = 'DataGlobalUpdate';
export const fields = {
  id: 'id',
  idLastUpdate: 'idLastUpdate',
  lastUpdate: 'lastUpdate',
  manageBy: 'manageBy'
};
const schema = {
  name,
  columns: [
    { name: fields.id, type: 'integer PRIMARY KEY  AUTOINCREMENT' },
    { name: fields.idLastUpdate, type: 'text' },
    { name: fields.lastUpdate, type: 'text' },
    { name: fields.manageBy, type: 'text' }
  ],
  pk: [fields.id],
};
export default schema;
